module.exports = __webpack_public_path__ + "ionicons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.woff?v=2.0.1
// module id = 1572
// module chunks = 6